import { TechnicalObjectOracle } from 'src/models/technical-object';
import { TechnicalObject } from '@models';
import { TechnicalObjectMarkerType } from './types';

export const getTechnicalObjectType = (
  technicalObject: Partial<TechnicalObject> | TechnicalObjectOracle
): TechnicalObjectMarkerType => {
  const code = technicalObject.type?.code as TechnicalObjectMarkerType;
  if (!code) {
    return TechnicalObjectMarkerType.UNKNOWN;
  }

  if (code === TechnicalObjectMarkerType.NN_KABLOVY_SUBOR) {
    const connectCategory = technicalObject.connectCategory;
    if (connectCategory === 'COUPLER') {
      return TechnicalObjectMarkerType.NN_KABLOVY_SUBOR_SPOJKA;
    } else if (connectCategory === 'END_PIECE') {
      return TechnicalObjectMarkerType.NN_KABLOVY_SUBOR_KONCOVKA;
    } else {
      return TechnicalObjectMarkerType.UNKNOWN;
    }
  }

  if (code === TechnicalObjectMarkerType.VN_KABLOVY_SUBOR) {
    const connectCategory = technicalObject.connectCategory;
    if (connectCategory === 'COUPLER') {
      return TechnicalObjectMarkerType.VN_KABLOVY_SUBOR_SPOJKA;
    } else if (connectCategory === 'END_PIECE') {
      return TechnicalObjectMarkerType.VN_KABLOVY_SUBOR_KONCOVKA;
    } else {
      return TechnicalObjectMarkerType.UNKNOWN;
    }
  }
  return code;
};

export const getVoltageLevel = (
  technicalObject: Partial<TechnicalObject> | TechnicalObjectOracle
): string => {
  if (technicalObject.type?.voltageLevel?.code) {
    return technicalObject.type?.voltageLevel?.code as string;
  }
  const oracleId = (technicalObject as TechnicalObjectOracle)?.type?.oracleCode;
  if (oracleId) {
    return ORACLE_VOLTAGE[oracleId] ?? 'TS';
  }
  return 'TS';
};

export const getToLabel = (
  technicalObject: Partial<TechnicalObject> | TechnicalObjectOracle
): string => {
  if ((technicalObject as TechnicalObject)?.name) {
    return (technicalObject as TechnicalObject).name as string;
  }

  return technicalObject?.fid ?? '?';
};

const ORACLE_VOLTAGE: Record<string, string> = {
  346: 'VVN',
  304: 'VVN',
  305: 'VN',
  306: 'NN',
  323: 'TS',
  347: 'VN',
  324: 'NN',
  328: 'GND',
  331: 'GND',
  1080: 'NN',
};

/*
TODO: mozno bude treba vratit a odfiltrovat tieto, ktore maju byt skryte aj ked maju coordinates
const ORACLE_HIDDEN_TYPES = [
  311, // "Ele-Vypínač vzduch VN"
  321, // "Ele-Transformátor"
  349, // "Ele-Kobka/Vyvod VN"
];
*/
